import { createFileRoute } from "@tanstack/react-router";
import { EnvioColaboradorConfig } from "@/features/envio-colaborador-config";
import { requireAdmin } from "@/lib/route-guards";

export const Route = createFileRoute("/_authenticated/envio-colaborador/")({
  beforeLoad: async () => {
    await requireAdmin();
  },
  component: EnvioColaboradorConfig,
});
